import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { getStyle } from '../../../utils/utils';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import axios from 'axios';
import CBLabelAndValue from '../../shared/CBLabelAndValue';
import CBButtonSettingsWhite from '../../shared/CBButtonSettingsWhite';
import CBButtonWithIconSmall from '../../shared/CBButtonWithIconSmall';
import CBSpinner from '../../shared/CBSpinner';

class ManufacturerServiceBook extends React.Component {
  constructor(props) {
    super(props);
    const { workshops, selectedWorkshopId } = props;
    const selectedWorkshop = workshops.find(ws => ws.id === selectedWorkshopId);

    this.state = {
      formData: {
        email: selectedWorkshop && selectedWorkshop.email || '',
        country: 'FI',
        language: 'FI',
        firstname: selectedWorkshop && selectedWorkshop.contact_name && selectedWorkshop.contact_name.split(' ')[0] || '',
        lastname: selectedWorkshop && selectedWorkshop.contact_name && selectedWorkshop.contact_name.split(' ').slice(1).join(' ') || '',
        telephone: selectedWorkshop && selectedWorkshop.phone_number || '',
        name: selectedWorkshop && selectedWorkshop.name || '',
        address: selectedWorkshop && selectedWorkshop.street_address || '',
        city: selectedWorkshop && selectedWorkshop.city || '',
        zipcode: selectedWorkshop && selectedWorkshop.zip_code || '',
      },
      loading: false,
      result: null,
      error: null
    };
  }

  componentDidUpdate(prevProps) {
    // Handle both when workshops load initially and when selectedWorkshopId changes
    if ((this.props.workshops != prevProps.workshops && this.props.workshops.length > 0) ||
        this.props.selectedWorkshopId !== prevProps.selectedWorkshopId) {

      const selectedWorkshop = this.props.workshops.find(ws => ws.id == this.props.selectedWorkshopId);

      if (selectedWorkshop) {
        this.setState({
          formData: {
            ...this.state.formData,
            email: selectedWorkshop.email || '',
            firstname: selectedWorkshop.contact_name && selectedWorkshop.contact_name.split(' ')[0] || '',
            lastname: selectedWorkshop.contact_name && selectedWorkshop.contact_name.split(' ').slice(1).join(' ') || '',
            telephone: selectedWorkshop.phone_number || '',
            name: selectedWorkshop.name || '',
            address: selectedWorkshop.street_address || '',
            city: selectedWorkshop.city || '',
            zipcode: selectedWorkshop.zip_code || '',
          }
        });
      }
    }
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value
      }
    }));
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true, error: null, result: null });

    try {
      const response = await axios.post(
        '/api/1/integrations/oe/workshop-signup/',
        {
          ...this.state.formData,
          workshop_id: this.props.selectedWorkshopId
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }
      );

      if (response.data.data.url) {
        window.location.href = response.data.data.url;
      } else {
        this.setState({
          loading: false,
          result: response.data
        });
      }
    } catch (error) {
      const errorMessage = error.response && error.response.data && error.response.data.error
        ? error.response.data.error
        : 'An error occurred during signup';

      this.setState({
        loading: false,
        error: errorMessage
      });
    }
  };

  handleOEAuth = () => {
    window.location.href = `/api/1/integrations/oe/login/${this.props.selectedWorkshopId}/`;
  };

  render() {
    const { t } = this.props;
    const { formData, loading, result, error } = this.state;

    // Convert both IDs to strings for comparison
    const selectedWorkshop = this.props.workshops.find(ws =>
      ws.id == this.props.selectedWorkshopId
    );

    const hasOEIntegration = selectedWorkshop && selectedWorkshop.oe_integration;

    if (!selectedWorkshop) {
      return (
        <div style={styles.default.container}>
          <CBSpinner />
        </div>
      );
    }

    if (selectedWorkshop && !selectedWorkshop.feature_manufacturer_service_book) {
      return (
        <div style={styles.default.container}>
          <h2 style={styles.title}>{t('manufacturerServiceBook', {ns: 'WSSettingsView'})}</h2>
          <p>{t('manufacturerServiceBookDisabled', {ns: 'WSSettingsView'})}</p>
        </div>
      );
    }

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            <h2 style={styles.title}>{t('manufacturerServiceBook', {ns: 'WSSettingsView'})}</h2>

            {hasOEIntegration ? (
              <div style={styles.integrationContainer}>
                <CBLabelAndValue
                  label={t('status', {ns: 'WSSettingsView'})}
                  value={selectedWorkshop.oe_integration.status_display}
                />

                {selectedWorkshop.oe_integration.status == 0 && selectedWorkshop.oe_integration.registration_url && (
                  <div style={styles.authContainer}>
                    <CBButtonWithIconSmall
                      text={t('finalizeRegistration', {ns: 'WSSettingsView'})}
                      onClick={this.handleOEAuth}
                    />
                  </div>
                )}
                <React.Fragment>
                  <CBLabelAndValue
                    label={t('isAuthenticated', {ns: 'WSSettingsView'})}
                    value={selectedWorkshop.oe_integration.is_authenticated ? t('yes', {ns: 'common'}) : t('no', {ns: 'common'})}
                  />
                  <div style={styles.authContainer}>
                    <CBButtonWithIconSmall
                      text={t('authenticateWithOE', {ns: 'WSSettingsView'})}
                      onClick={this.handleOEAuth}
                    />
                  </div>
                </React.Fragment>
              </div>
            ) : (
              <div style={styles.card}>
                <form onSubmit={this.handleSubmit} style={styles.form}>
                  <div style={styles.formGrid}>
                    <div style={styles.formField}>
                      <label htmlFor="email" style={styles.label}>{t('email', {ns: 'WSSettingsView'})}</label>
                      <InputText
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={this.handleInputChange}
                        required
                        style={styles.input}
                      />
                    </div>

                    <div style={styles.formField}>
                      <label htmlFor="name" style={styles.label}>{t('workshopName', {ns: 'WSSettingsView'})}</label>
                      <InputText
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={this.handleInputChange}
                        required
                        style={styles.input}
                      />
                    </div>

                    <div style={styles.formField}>
                      <label htmlFor="firstname" style={styles.label}>{t('firstName', {ns: 'WSSettingsView'})}</label>
                      <InputText
                        id="firstname"
                        name="firstname"
                        value={formData.firstname}
                        onChange={this.handleInputChange}
                        required
                        style={styles.input}
                      />
                    </div>

                    <div style={styles.formField}>
                      <label htmlFor="lastname" style={styles.label}>{t('lastName', {ns: 'WSSettingsView'})}</label>
                      <InputText
                        id="lastname"
                        name="lastname"
                        value={formData.lastname}
                        onChange={this.handleInputChange}
                        required
                        style={styles.input}
                      />
                    </div>

                    <div style={styles.formField}>
                      <label htmlFor="telephone" style={styles.label}>{t('phoneNumber', {ns: 'WSSettingsView'})}</label>
                      <InputText
                        id="telephone"
                        name="telephone"
                        value={formData.telephone}
                        onChange={this.handleInputChange}
                        required
                        style={styles.input}
                      />
                    </div>

                    <div style={styles.formField}>
                      <label htmlFor="address" style={styles.label}>{t('address', {ns: 'WSSettingsView'})}</label>
                      <InputText
                        id="address"
                        name="address"
                        value={formData.address}
                        onChange={this.handleInputChange}
                        required
                        style={styles.input}
                      />
                    </div>

                    <div style={styles.formField}>
                      <label htmlFor="city" style={styles.label}>{t('city', {ns: 'WSSettingsView'})}</label>
                      <InputText
                        id="city"
                        name="city"
                        value={formData.city}
                        onChange={this.handleInputChange}
                        required
                        style={styles.input}
                      />
                    </div>

                    <div style={styles.formField}>
                      <label htmlFor="zipcode" style={styles.label}>{t('zipCode', {ns: 'WSSettingsView'})}</label>
                      <InputText
                        id="zipcode"
                        name="zipcode"
                        value={formData.zipcode}
                        onChange={this.handleInputChange}
                        required
                        style={styles.input}
                      />
                    </div>
                  </div>

                  <div style={styles.buttonContainer}>
                    <Button
                      type="submit"
                      label={loading ? t('submitting', {ns: 'common'}) : t('submit', {ns: 'common'})}
                      disabled={loading}
                      style={styles.submitButton}
                    />
                  </div>

                  {error && (
                    <Message severity="error" text={error} style={styles.message} />
                  )}

                  {result && (
                    <div style={styles.resultContainer}>
                      <Message severity="success" text={t('preSignupSuccessful', {ns: 'WSSettingsView'})} style={styles.message} />
                      {result.data && result.data.url && (
                        <div style={styles.urlContainer}>
                          <a href={result.data.url} target="_blank" rel="noopener noreferrer" style={styles.urlLink}>
                            {t('completeRegistration', {ns: 'WSSettingsView'})}
                          </a>
                        </div>
                      )}
                    </div>
                  )}
                </form>
              </div>
            )}
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      padding: '2rem',
      backgroundColor: '#0095DA',
      minHeight: 'calc(100vh - 60px)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '1rem'
    },
  },
  medium: {
    container: {
      padding: '1.5rem',
    }
  },
  title: {
    color: '#FFF',
    fontSize: '1.25rem',
    fontWeight: '400',
    marginBottom: '1.5rem'
  },
  integrationContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%'
  },
  card: {
    width: '100%',
    maxWidth: '800px',
    backgroundColor: 'white',
    borderRadius: '4px',
    boxShadow: 'none',
    padding: '2rem'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '1rem',
  },
  formField: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
  label: {
    fontSize: '0.875rem',
    color: '#333',
    marginBottom: '0.25rem'
  },
  input: {
    width: '100%',
    padding: '0.5rem',
    borderRadius: '2px',
    border: '1px solid #ddd',
    fontSize: '0.875rem',
    ':focus': {
      borderColor: '#0095DA',
      outline: 'none'
    }
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: '1.5rem',
  },
  submitButton: {
    padding: '0.5rem 1.5rem',
    fontSize: '0.875rem',
    backgroundColor: '#4285f4',
    border: 'none',
    color: 'white',
    borderRadius: '2px',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#3367d6'
    }
  },
  message: {
    marginTop: '1rem',
    fontSize: '0.875rem'
  },
  resultContainer: {
    marginTop: '1rem',
    padding: '1rem',
    backgroundColor: '#f8f9fa',
    borderRadius: '2px',
  },
  urlContainer: {
    marginTop: '0.5rem',
  },
  urlLink: {
    color: '#0095DA',
    textDecoration: 'none',
    fontSize: '0.875rem',
    ':hover': {
      textDecoration: 'underline'
    }
  },
  authContainer: {
    marginTop: '1rem',
    width: 250,
  },
  authButton: {
    backgroundColor: '#4285f4',
    color: 'white',
    border: 'none',
    padding: '0.5rem 1rem',
    borderRadius: '2px',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#3367d'
    }
  }
};

function mapStateToProps(state) {
  return {
    selectedWorkshopId: state.workshop.selectedWorkshop,
    workshops: state.workshop.workshops,
  };
}

export default connect(mapStateToProps)(translate('WSSettingsView')(ManufacturerServiceBook));
